package com.royceecoleman.bill.aichat

import com.royceecoleman.bill.auth.authenticatedFetch
import com.royceecoleman.bill.shared.aichat.AiChatSessionDto
import com.royceecoleman.bill.shared.aichat.AiModelDto
import com.royceecoleman.bill.shared.aichat.ChatTurnDto
import com.royceecoleman.bill.shared.aichat.CreateSessionRequest
import com.royceecoleman.bill.shared.aichat.SendMessageRequest
import com.royceecoleman.bill.shared.aichat.SendMessageResponse
import com.royceecoleman.bill.shared.aichat.UpdateSessionModelRequest
import kotlinx.coroutines.await
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json

private const val AI_CHAT_BASE_PATH = "/api/aichat/unified"

private val aiChatJson = Json { ignoreUnknownKeys = true; explicitNulls = false }

suspend fun fetchAiModels(): List<AiModelDto> = getJson("$AI_CHAT_BASE_PATH/models")

suspend fun fetchAiChatSessions(): List<AiChatSessionDto> = getJson("$AI_CHAT_BASE_PATH/sessions")

suspend fun fetchAiChatSessionTurns(sessionId: Long): List<ChatTurnDto> = getJson("$AI_CHAT_BASE_PATH/sessions/$sessionId/turns")

suspend fun createAiChatSession(request: CreateSessionRequest = CreateSessionRequest()): AiChatSessionDto =
    sendJson(
        path = "$AI_CHAT_BASE_PATH/sessions",
        method = "POST",
        request = request,
    )

suspend fun updateAiChatSessionModel(
    sessionId: Long,
    modelId: String,
): AiChatSessionDto =
    sendJson(
        path = "$AI_CHAT_BASE_PATH/sessions/$sessionId/model",
        method = "PUT",
        request = UpdateSessionModelRequest(modelId = modelId),
    )

suspend fun sendAiChatMessage(
    sessionId: Long,
    text: String,
): SendMessageResponse =
    sendJson(
        path = "$AI_CHAT_BASE_PATH/sessions/$sessionId/messages",
        method = "POST",
        request = SendMessageRequest(text = text),
    )

private suspend inline fun <reified T> getJson(path: String): T {
    val response = authenticatedFetch(path = path, method = "GET")
    val responseText = response.text().await()

    if (!response.ok) {
        throw IllegalStateException(responseText.ifBlank { "Request to $path failed." })
    }

    return aiChatJson.decodeFromString(responseText)
}

private suspend inline fun <reified Request, reified Response> sendJson(
    path: String,
    method: String,
    request: Request,
): Response {
    val response =
        authenticatedFetch(
            path = path,
            method = method,
            body = aiChatJson.encodeToString(request),
            contentType = "application/json",
        )
    val responseText = response.text().await()

    if (!response.ok) {
        throw IllegalStateException(responseText.ifBlank { "Request to $path failed." })
    }

    return aiChatJson.decodeFromString(responseText)
}
